
<template>
  <Loader v-if="loader" />

  <div class="card p-3">
    <div class="grid form-file">
      <div class="col-12 md:col-4">
        <label>File</label>
        <div class="button-wrapper">
          <span :class="['label', {'active': fileToUpload.length > 0}]">
            {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
          </span>
          <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
        </div>
        <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
        <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
        <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
      </div>
      <div class="col-12 lg:col-3">
        <label>Tipo fornitura</label>
        <Dropdown
          v-model="selectedTypeFornitura"
          :options="typesFornitura"
          optionLabel="name"
          optionValue="name"
          class="inputfield w-full"
        />
      </div>
      <div class="col-12 lg:col-3">
        <label>Decorrenza switch-out</label>
        <Calendar
          v-model="selectedDate"
          dateFormat="mm-yy"
          view="month"
          class="inputfield w-full"
          showIcon
        />
      </div>
      <div class="col-12 lg:col-2">
        <label><br></label>
        <Button
          label="Cerca"
          @click="searchData"
          icon="pi pi-search"
          iconPos="right"
          class="w-full"
        />
      </div>
    </div>
  </div>

  <div v-if="items.length > 0">
    <DataTable
      ref="dt"
      :value="items"
      rowGroupMode="rowspan"
      groupRowsBy="fornitura_code"
      sortMode="single"
      sortField="fornitura_code"
      :sortOrder="1"
      tableStyle="width: 100%"
      :filters="filters"
      exportFilename="recessi"
    >
      <template #header>
        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center mb-2">
              <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
              </span>
            </div>
            <div class="flex align-items-center justify-content-center">
              <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
            </div>
        </div>
      </template>
      <template #empty>
          <div class="text-center">Nessun dato trovato.</div>
      </template>
      <Column
        field="fornitura_code"
        header="Fornitura"
        style="width: 140px"
      >
        <template #body="slotProps">
          <div class="flex align-items-center gap-2">
            <span>{{ slotProps.data.fornitura_code }}</span>
          </div>
        </template>
      </Column>
      <Column field="cod_servizio" header="Code" :sortable="true" />
      <Column field="type" header="Tipo" :sortable="true" />
      <!-- <Column field="cod_pratica" header="Cod. Pratica" :sortable="true" /> -->
      <Column field="cod_pratica_provider" header="Cod. Pratica Provider" :sortable="true" style="min-width: 140px" >
          <template #body="slotProps">
            {{slotProps.data.cod_pratica_provider}}
          </template>
      </Column>
      <Column field="data_esito" header="Data Esito" :sortable="true">
          <template #body="slotProps">
          {{formatDate(slotProps.data.data_esito)}}
          </template>
      </Column>
      <Column field="data_decorrenza" header="Data Decorrenza" :sortable="true">
          <template #body="slotProps">
          {{formatDate(slotProps.data.data_decorrenza)}}
          </template>
      </Column>
      <Column field="annullata" header="Stato">
          <template #body="slotProps">
              <Tag @click="viewAnnulledPratica(slotProps.data)" :value="slotProps.data.annullata ? 'Annullata' : 'Evasa'" :severity="getSeverity(slotProps.data.annullata)" style="min-width: 100px" class="cursor-pointer" />
          </template>
      </Column>
    </DataTable>
  </div>

  <!-- modal show annulled pratica -->
  <Dialog v-model:visible="dialogAnnulled" modal header="Pratica Annullata" :style="{ width: '80vw' }">
    <DataTable :value="annulled">
        <Column field="fornitura_code" header="Fornitura" />
        <Column field="type" header="Tipo" />
        <Column field="cod_pratica" header="Cod. Pratica Annullata" />
        <Column field="cod_pratica_provider" header="Cod. Pratica Provider" />
        <Column field="motivazione_esito" header="Motivazione" />
    </DataTable>
  </Dialog> 

</template>

<script>
import { FilterMatchMode } from "primevue/api";
import Service from "@/services/ask-pratiche/pratiche-service";
import { ref, getCurrentInstance } from "vue";
import Loader from "@/components/Loader.vue";
import moment from "moment";

export default {
  components: {
    Loader,
  },
  setup() {
    const dt = ref();
    const loader = ref(false);
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const service = new Service(self.$http, self.$eventBus);
    const items = ref([]);
    const selectedDate = ref(new Date());
    const typesFornitura = ref([{ name: "POD" }, { name: "PDR" }]);
    const selectedTypeFornitura = ref(typesFornitura.value[0].name);
    const dialogAnnulled = ref(false);
    const annulled = ref([]);
    const fileToUpload = ref([])
    const allowedType = {
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
    const validationErrors = ref({})
    const submitted = ref(false)


    const searchData = () => {
      submitted.value = true
      if (validateForm()) {
        loader.value = true;
        let d = moment(selectedDate.value).format("YYYY-MM-DD");
        
        service.getCheckRecessi(selectedTypeFornitura.value, d, fileToUpload.value)
        .then((res) => {
          items.value = res.items;
        })
        .finally(() => {
          loader.value = false;
        });
      }
    };

    const viewAnnulledPratica = (data) => {
      annulled.value = []
      if (Object.keys(data.annullamenti).length !== 0) {
        dialogAnnulled.value = true
        annulled.value.push(data.annullamenti)
      }
    }

    const getSeverity = (annullata) => {
      if (annullata) {
        return 'danger';
      } else {
        return 'success';
      }
    };

    const handleFileUpload = async (evt) => {
      evt.preventDefault()
      fileToUpload.value = []
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
    }

    const validateForm = () => {

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    return {
      dt,
      loader,
      formatDate,
      filters,
      searchData,
      selectedDate,
      items,
      selectedTypeFornitura,
      typesFornitura,
      getSeverity,
      viewAnnulledPratica,
      dialogAnnulled,
      annulled,
      fileToUpload,
      allowedType,
      submitted,
      validationErrors,
      handleFileUpload,
      exportCSV,
      
      // moment
    };
  },
};
</script>


<style scoped>

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
.box-wrapper .box {
  cursor: pointer;
}
.box-wrapper .box .card {
    background-color: #f4f4f4;
    padding-bottom: 8px;
}
.box-wrapper .highlight .card{
  /* background: rgba(66, 244, 17, 0.195); */
  border-bottom: 6px solid rgb(18, 158, 251);
  background-color: #fff;
}
</style>
